export const SEARCH_PRICE_RANGE_SELECT = Symbol('SEARCH_PRICE_RANGE_SELECT_EVENT_ID');
export const SEARCH_PRICE_RANGE_CONFIRM = Symbol('SEARCH_PRICE_RANGE_CONFIRM_EVENT_ID');
export const SEARCH_PRICE_RANGE_CHANGE = Symbol('SEARCH_PRICE_RANGE_CHANGE_EVENT_ID');
export const PRICE_RANGE_FILTER_ID = 'PriceRangeFilter';
export const SEARCH_FILTERS_INIT = Symbol('SEARCH_FILTERS_INIT_EVENT_ID');
export const SEARCH_API_RESPONSE_SUCCESS = Symbol('SEARCH_API_RESPONSE_SUCCESS_EVENT_ID');
